import { render, staticRenderFns } from "./ShowAssessment.vue?vue&type=template&id=5a6e82a2"
import script from "./ShowAssessment.vue?vue&type=script&lang=js"
export * from "./ShowAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports